import { render, staticRenderFns } from "./BlogWidget.vue?vue&type=template&id=6730ca59&scoped=true"
import script from "./BlogWidget.vue?vue&type=script&lang=js"
export * from "./BlogWidget.vue?vue&type=script&lang=js"
import style0 from "./BlogWidget.vue?vue&type=style&index=0&id=6730ca59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6730ca59",
  null
  
)

export default component.exports